window.addEventListener('DOMContentLoaded', () => {
  // ===== Sticky ATC show/hide (mobile) =====
  if (window.innerWidth < 768) {
    const mainATC = document.querySelector('[data-product-atc]');
    const stickyATC = document.querySelector('[data-product-sticky-atc]');

    if (mainATC && stickyATC) {
      const header = document.querySelector('[data-site-header]');
      const announcement = document.querySelector('[data-site-announcement-bar]');
      const headerHeight =
        (header ? header.offsetHeight : 0) + (announcement ? announcement.offsetHeight : 0);

      const observer = new IntersectionObserver(
        ([entry]) => {
          const show = !entry.isIntersecting;
          stickyATC.classList.toggle('visible', show);
          document.body.classList.toggle('has-sticky-atc', show);
        },
        {
          root: null,
          threshold: 0,
          rootMargin: `-${headerHeight}px 0px 0px 0px`,
        }
      );

      observer.observe(mainATC);
    }
  }

  // ===== Quantity sync =====
  const mainQtyInput = document.querySelector(".product__form input[name='quantity']");
  const stickyQtyInput = document.querySelector('#sticky_atc_quantity');

  if (!mainQtyInput || !stickyQtyInput) return;

  const setStickyFromMain = () => {
    stickyQtyInput.value = mainQtyInput.value;
  };

  const setMainFromSticky = () => {
    mainQtyInput.value = stickyQtyInput.value;
    mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  // Sync when user types in either input
  mainQtyInput.addEventListener('change', setStickyFromMain);
  stickyQtyInput.addEventListener('change', setMainFromSticky);

  // Sync sticky when theme +/- is clicked
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-quantity-change-button]')) return;
    requestAnimationFrame(setStickyFromMain);
  });

  // ===== Sticky +/- buttons =====
  document.addEventListener('click', e => {
    const plus = e.target.closest('[data-sticky-qty-plus]');
    const minus = e.target.closest('[data-sticky-qty-minus]');
    if (!plus && !minus) return;

    const current = parseInt(stickyQtyInput.value, 10) || 0;

    const next = minus ? current - 1 : current + 1;
    stickyQtyInput.value = String(Math.max(1, next));

    // Triggers sync to main via listeners above
    stickyQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Initial sync
  setStickyFromMain();
});
